export enum AuthFlowType {
  CREDENTIALS = 'credentials',
  SITE_CREDENTIALS = 'site-credentials',
  SITE_CREDENTIALS_PW_RECOVER = 'site-credentials-pw-recover'
}


export enum AuthStepType {
  VALIDATE_PASSWORD = 'validate-password',
  SET_PASSWORD = 'set-password',
  VERIFY_OTP = 'verify-otp',
  RECOVER_PIN = 'recover-pin',
  PHONE_ASSOCIATION = 'phone-association',
  EMAIL_ASSOCIATION = 'email-association',
  MFA_VALIDATION = 'mfa-validation'
}

export enum FlowType {
  ASSOCIATION = 'association',
  DEFINITION = 'definition',
}

export interface FlowConfig {
  form: string;
  flow: AuthFlowType;
  type: FlowType,
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    input: string;
    placeholder?: string;
    inputAria: {
      required: string;
    }
    nextButton: string;
    nextButtonAria: {
      enabled: string;
      disabled: string;
    }
  },
  skipStep: boolean,
  backSteps: number;
  canCreateCard: boolean;
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.CREDENTIALS]: {
    form: "card_association__" + AuthFlowType.CREDENTIALS,
    flow: AuthFlowType.CREDENTIALS,
    type: FlowType.ASSOCIATION,
    labels: {
      headerTitle: "card_association.header_title",
      headerSubtitle: "card_association.header_message",
      input: 'card_association.card_number_input',
      placeholder: 'card_association.card_number_placeholder',
      inputAria: {
        required: 'accessibility.loyaltycard.loyalty_card_association.input',
      },
      nextButton: 'card_association.button_next_message',
      nextButtonAria: {
        enabled: "accessibility.loyaltycard.loyalty_card_association.button.submit",
        disabled: "accessibility.loyaltycard.loyalty_card_association.button.cant_submit",
      }
    },
    backSteps: 0,
    skipStep: true,
    canCreateCard: true
  },
  [AuthFlowType.SITE_CREDENTIALS]: {
    form: "card_association__" + AuthFlowType.SITE_CREDENTIALS,
    flow: AuthFlowType.SITE_CREDENTIALS,
    type: FlowType.DEFINITION,
    labels: {
      headerTitle: "site_credentials.loyaltycard_association.definition.header_title",
      headerSubtitle: "site_credentials.loyaltycard_association.definition.header_message",
      input: 'site_credentials.loyaltycard_association.definition.card_number_input',
      placeholder: 'site_credentials.loyaltycard_association.definition.card_number_placeholder',
      inputAria: {
        required: 'accessibility.loyaltycard.loyalty_card_association.input',
      },
      nextButton: 'site_credentials.loyaltycard_association.definition.button_next_message',
      nextButtonAria: {
        enabled: "site_credentials.loyaltycard_association.definition.button_next_message",
        disabled: "site_credentials.loyaltycard_association.definition.button_next_message",
      }
    },
    skipStep: false,
    backSteps: 1,
    canCreateCard: true
  },
  [AuthFlowType.SITE_CREDENTIALS_PW_RECOVER]: {
    form: "card_association__" + AuthFlowType.SITE_CREDENTIALS_PW_RECOVER,
    flow: AuthFlowType.SITE_CREDENTIALS_PW_RECOVER,
    type: FlowType.ASSOCIATION,
    labels: {
      headerTitle: "site_credentials.card_validation.header_title",
      headerSubtitle: "site_credentials.card_validation.header_message",
      input: 'site_credentials.card_validation.card_number_input',
      inputAria: {
        required: 'accessibility.loyaltycard.loyalty_card_association.input',
      },
      nextButton: 'site_credentials.button_next_message',
      nextButtonAria: {
        enabled: "site_credentials.button_next_message",
        disabled: "site_credentials.button_next_message",
      }
    },
    skipStep: false,
    backSteps: 1,
    canCreateCard: false
  }
}